export default function avatar({ variables }) {
    return {
        MuiAvatar: {
            styleOverrides: {
                root: {
                    width: variables.icon_size_md,
                    height: variables.icon_size_md,
                    fontSize: variables.type_micro_font_size,
                    fontWeight: variables.font_weight_medium,
                },
                colorDefault: {
                    backgroundColor: variables.surface_subtle,
                    color: variables.text_medium,
                },
                rounded: {
                    borderRadius: variables.border_radius_small,
                },
            },
        },
        MuiAvatarGroup: {
            styleOverrides: {
                avatar: {
                    width: variables.icon_size_md,
                    height: variables.icon_size_md,
                    fontSize: variables.type_micro_font_size,
                    borderColor: variables.surface,
                },
            },
        },
    };
}
//# sourceMappingURL=avatar.js.map